import { createIcon } from '@chakra-ui/react';

export const Partner = createIcon({
  displayName: 'People',
  viewBox: '0 0 32 32',
  path: (
    <>
      <rect
        id="bg"
        width="32"
        height="32"
        transform="translate(0 0)"
        fill="none"
      />
      <g id="SJ-Icon-B_Partner_Red_RGB" transform="translate(0.003)">
        <path
          id="Path_2182"
          data-name="Path 2182"
          d="M28.7,48.894a1.286,1.286,0,0,1-.758-.247l-3.291-2.39-3.29,2.39A1.29,1.29,0,0,1,19.376,47.2l1.257-3.868-3.29-2.39a1.291,1.291,0,0,1,.758-2.335h4.066l1.257-3.868a1.29,1.29,0,0,1,2.454,0h0l1.257,3.868H31.2a1.291,1.291,0,0,1,.758,2.335l-3.289,2.39L29.929,47.2a1.292,1.292,0,0,1-1.228,1.69Zm-4.049-4.369a.776.776,0,0,1,.455.148l3.1,2.254L27.024,43.28a.776.776,0,0,1,.281-.866l3.1-2.254H26.573a.775.775,0,0,1-.737-.535l-1.185-3.647-1.185,3.647a.774.774,0,0,1-.737.535H18.9L22,42.414a.775.775,0,0,1,.281.866l-1.185,3.647,3.1-2.254A.779.779,0,0,1,24.652,44.525Z"
          transform="translate(-8.653 -16.894)"
          fill="currentColor"
        />
        <path
          id="Path_2183"
          data-name="Path 2183"
          d="M32.228,42.977H23.34a.774.774,0,1,1,0-1.549h7.916L30,35.955a5.38,5.38,0,0,0-3.362-3.862,27.693,27.693,0,0,0-19.276,0A5.38,5.38,0,0,0,4,35.955L2.751,41.428h7.916a.774.774,0,1,1,0,1.549H1.78a.775.775,0,0,1-.755-.947l1.47-6.42a6.926,6.926,0,0,1,4.331-4.968,29.243,29.243,0,0,1,20.357,0,6.925,6.925,0,0,1,4.331,4.968l1.47,6.42a.774.774,0,0,1-.755.947Z"
          transform="translate(-1.006 -14.456)"
          fill="currentColor"
        />
        <path
          id="Path_2184"
          data-name="Path 2184"
          d="M26.234,13.3A6.152,6.152,0,1,1,32.386,7.15,6.159,6.159,0,0,1,26.234,13.3Zm0-10.755a4.6,4.6,0,1,0,4.6,4.6A4.608,4.608,0,0,0,26.234,2.547Z"
          transform="translate(-10.235 -0.998)"
          fill="currentColor"
        />
      </g>
    </>
  ),
});
